<template>
  <content-placeholders :rounded="true" class="dd-content-placeholders">
    <template v-if="viewType==='grid'">
      <content-placeholders-img class="dd-content-placeholders__heading" />
      <div class="row">
        <div class="col-12 col-lg-6 col-xl-4 dd-content-placeholders__entity-grid">
          <content-placeholders-img />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 dd-content-placeholders__entity-grid">
          <content-placeholders-img />
        </div>
        <div class="col-12 col-lg-6 col-xl-4 dd-content-placeholders__entity-grid">
          <content-placeholders-img />
        </div>
      </div></template>
    <template v-else-if="viewType==='table'">
      <content-placeholders-img class="dd-content-placeholders__heading" />
      <div class="row">
        <div class="col-12 dd-content-placeholders__entity-table">
          <content-placeholders-img />
        </div>
        <div class="col-12 dd-content-placeholders__entity-table">
          <content-placeholders-img />
        </div>
        <div class="col-12 dd-content-placeholders__entity-table">
          <content-placeholders-img />
        </div>
        <div class="col-12 dd-content-placeholders__entity-table">
          <content-placeholders-img />
        </div>
        <div class="col-12 dd-content-placeholders__entity-table">
          <content-placeholders-img />
        </div>
      </div>
    </template>
  </content-placeholders>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersImg,
} from '@/components/global/content-placeholders'

export default defineComponent({
  components: { ContentPlaceholders, ContentPlaceholdersImg },

  props: {
    viewType: {
      type: String,
      default: 'grid',
    },
  },
})
</script>

<style lang="scss" scoped>
.dd-content-placeholders {
  &__heading {
    width: 81.5%;
    max-width: 200px;
    height: 30px;
    margin-bottom: 20px;
  }

  &__grid-row {
    margin-top: 14px;
  }

  &__entity-grid,
  &__entity-table {
    width: 100%;
  }

  &__entity-grid {
    > div {
      height: 150px;
      margin-bottom: 20px;
    }
  }
  &__entity-table {
    > div {
      height: 30px;
      margin-bottom: 10px;
    }
  }
}
</style>
